import React, {lazy, Suspense, useEffect, useRef, useState} from "react";
import { HashRouter } from "react-router";
import { Provider } from "react-redux";

import appInit from "./application/appInit";

/* Components */
import LoadingSpinner, { SpinnerSize } from "./components/general/LoadingSpinner/LoadingSpinner";
import { ToastContainer } from "react-toastify";

/* Redux */
import { store } from "./Redux/store";

/* styles */
import "./App.scss";
import "./styles/toastMessages.scss";

const AppRoutes = lazy(() => import("./routes/AppRoutes"));
const AppContext = lazy(() => import("./application/AppContext"));
const ListInformationModalContext = lazy(() => import("./contexts/Content/ListInformationModalContext"))

function App() {
  const [initLoaded, setInitLoaded] = useState<boolean>(false);
  const isMounted = useRef<boolean>(true);

  // App init
  useEffect(() => {
    (async () => {
      await appInit.setup();

      if (isMounted.current) {
        setInitLoaded(true);
      }
    })();

    return () => {
      isMounted.current = false;
    };
  }, []);

  // Wait until init loaded
  if (!initLoaded) {
    return null;
  }

  return (
    <Suspense fallback={<div className="page-loading-spinner"><LoadingSpinner spinnerSize={SpinnerSize.LARGE} /></div>}>
      <div id="react-app" className="react">
        <ToastContainer />
        <Provider store={store}>
          <HashRouter>
            <AppContext>
              <ListInformationModalContext>
                <AppRoutes/>
              </ListInformationModalContext>
            </AppContext>
          </HashRouter>
        </Provider>
      </div>
    </Suspense>
  );
}

export default App;
